import axios from "axios";
import axiosInstance from "../../../../Utils/axios";
import { paginationQueryParams } from "../../../../Utils/paginationParam";
let cancelToken;

const countryURL = `api/v1/location-app/country`;

//obtaining the paginated data
export const getCountry = ({ rowsPerPage, search, sortOrder, pageNo }) => {
  if (cancelToken) {
    cancelToken.cancel("Operation canceled due to new request.");
  }
  cancelToken = axios.CancelToken.source();

  return axiosInstance.get(`${countryURL}/list?${paginationQueryParams(rowsPerPage, search, sortOrder, pageNo)}`, {
    cancelToken: cancelToken.token,
  });
};

//obtaining all fiscal sessions
export const getAllCountry = () => axiosInstance.get(`${countryURL}/list?ordering=-id`);

//obtaining the previous page data from paginated data
export const getPrevious = (previous) => axiosInstance.get(previous);

//obtaining the next page data from paginated data
export const getNext = (next) => axiosInstance.get(next);

//obtaining the particular page data from paginated data
export const getPageCountry = ({ number, rowsPerPage, search }) =>
  axiosInstance.get(`${countryURL}/list?${paginationQueryParams(rowsPerPage, search, "", number)}`);

export const getCountryById = (id) => axiosInstance.get(`${countryURL}/retrieve/${id}`);

//creating function
export const createCountry = (body) => axiosInstance.post(`${countryURL}/create`, body);
//updating function
export const updateCountry = (id, body) => axiosInstance.patch(`${countryURL}/update/${id}`, body);

//searching function
export const handleSearch = (search, rowsPerPage) =>
  axiosInstance.get(`${countryURL}/list?offset=0&limit=${rowsPerPage}&search=${search}`);

// checking the redundant data
export const checkRedundantDataCountryName = (e, cancelToken) =>
  axiosInstance.get(`${countryURL}/list?name=${e.target.value.trim()}`, {
    cancelToken: cancelToken.token,
  });
